import { memo, useCallback } from "react"
import { Button, Col, Modal, Row, Spinner } from "react-bootstrap"
import { Controller, FormProvider, useForm } from "react-hook-form"
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import { TextField } from "@mui/material";
import SwalMessage from "../_Components/SwalMessage";
import _ from "lodash";
import ApiBasketItemPerson from "../../../core/api/api.basketItemPerson";
import { numberRegex } from "../../../core/utils/tools";

const EditCommisionPrice = ({
  selectedUsedCommision,
  setSelectedUsedCommision,
}) => {
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  } = useForm({
    defaultValues: {
      ...selectedUsedCommision,
      commissionPrice: selectedUsedCommision.agentCommisionPrice.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ","),
    }
  });
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  const onSubmit = useCallback(async (data) => {
    try {
      for (const key in data) {
        if (key != "commissionPrice") delete data[key]
      }
      data.commissionPrice = +data.commissionPrice.replaceAll(",", "")
      const response = await ApiBasketItemPerson.updateAgentCommissionPrice({ ...data, basketItemPersonId: selectedUsedCommision.id });

      if (response?.succeeded) {
        document.getElementById("submitButton").click();
        handleClose();
      }
      SwalMessage({ title: response.message, iSsuccess: response.succeeded });
    } catch (error) {
      console.log("error=", error);
    }
  }, [selectedUsedCommision])
  const handleClose = useCallback(() => {
    setSelectedUsedCommision(null)
  }, [setSelectedUsedCommision,])

  return (
    <div>
      <Modal centered size="md" show={!!selectedUsedCommision} onHide={handleClose}>
        <FormProvider {...methods}>
          <form id="form" onSubmit={handleSubmit(onSubmit)}>
            <Modal.Header closeButton>
              <Modal.Title>ویرایش مبلغ کمیسیون استفاده شده نمایندگان</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <Col xs="12">
                <Controller
                  className="mt-5"
                  name="agentName"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="نماینده"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      disabled
                      {...field}
                    />
                  )}
                />
                <Row>
                  <Col>
                    <Controller
                      className="mt-5"
                      name="id"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          label="بلیط"
                          margin="normal"
                          variant="outlined"
                          size="small"
                          disabled
                          {...field}
                        />
                      )}
                    />
                  </Col>
                  <Col>
                    <Controller
                      className="mt-5"
                      name="promoCode"
                      control={control}
                      render={({ field }) => (
                        <TextField
                          label="کد تخفیف"
                          margin="normal"
                          variant="outlined"
                          size="small"
                          disabled
                          {...field}
                        />
                      )}
                    />
                  </Col>
                </Row>
                <Controller
                  className="mt-5"
                  name="amusmentServiceName"
                  control={control}
                  render={({ field }) => (
                    <TextField
                      label="سرویس"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      disabled
                      {...field}
                    />
                  )}
                />
                <Controller
                  className="mt-5"
                  name="commissionPrice"
                  control={control}
                  rules={{ required: true }}
                  render={({ field }) => (
                    <TextField
                      label="مبلغ کمیسیون"
                      margin="normal"
                      variant="outlined"
                      size="small"
                      onInput={(e) => {
                        if (!numberRegex.test(e.target.value.replaceAll(",", "")) && e.target.value)
                          e.target.value = getValues("commissionPrice")
                        else
                          e.target.value = e.target.value.replaceAll(",", "").replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                        field.onChange(e)
                      }}
                      {...field}
                    />
                  )}
                />
                {errors.agentCommisionPrice && <div class="mt-2 pl-4 text-danger">**لطفا مبلغ کمیسیون را وارد نمایید</div>}
              </Col>
            </Modal.Body>
            <Modal.Footer>
              <Button variant="success" type="submit" disabled={isSubmitting}>
                {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                <SaveIcon /> ذخیره
              </Button>
              <Button variant="danger" onClick={handleClose}>
                <CloseIcon /> بستن
              </Button>
            </Modal.Footer>
          </form>
        </FormProvider>

      </Modal>
    </div >
  )
}

export default memo(EditCommisionPrice)